import birth_certificate from '../locales/en/birth_certificate.json';
import birth_medical_records from '../locales/en/birth_medical_records.json';
import common from '../locales/en/common.json';
import dna from '../locales/en/dna.json';
import family_info from '../locales/en/family_info.json';
import investigation from '../locales/en/investigation.json';
import investigation_sections from '../locales/en/investigation_sections.json';
import neighborhood_canvas from '../locales/en/neighborhood_canvas.json';
import prospect from '../locales/en/prospect.json';
import religion_info from '../locales/en/religion_info.json';
import residency_questions from '../locales/en/residency_questions.json';
import review from '../locales/en/review.json';
import school_info from '../locales/en/school_info.json';
import review_committee from '../locales/en/review_committee.json';
import social_media from '../locales/en/social_media.json';

export default {
  birth_certificate,
  birth_medical_records,
  common,
  dna,
  family_info,
  investigation,
  investigation_sections,
  neighborhood_canvas,
  prospect,
  religion_info,
  residency_questions,
  review,
  school_info,
  review_committee,
  social_media,
};
